@if (excludedKeys.length && excludedHint) {
  <p class="excluded-hint muted">{{ excludedHint }}</p>
}

@if (topLevelKeys.length === 0) {
  <p class="muted">Ingen felter endnu (ud over reserverede nøgler).</p>
}

<mat-accordion multi>
  @for (key of topLevelKeys; track key) {
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>{{ key }}</mat-panel-title>
        <mat-panel-description>{{ typeLabel(valueForKey(key)) }}</mat-panel-description>
      </mat-expansion-panel-header>
      <div class="panel-actions">
        <button mat-stroked-button color="warn" type="button" (click)="removeKey(key)">
          <mat-icon>delete</mat-icon>
          Slet nøgle
        </button>
      </div>
      <app-json-value-editor
        [value]="valueForKey(key)"
        [depth]="0"
        (valueChange)="onKeyValueChange(key, $event)"
      />
    </mat-expansion-panel>
  }
</mat-accordion>

<div class="add-top-level">
  <mat-form-field appearance="outline">
    <mat-label>Ny top-level nøgle</mat-label>
    <input matInput [(ngModel)]="newTopLevelKey" />
  </mat-form-field>
  <button mat-stroked-button type="button" (click)="addTopLevelKey()" [disabled]="!newTopLevelKey.trim()">
    Tilføj nøgle
  </button>
</div>
